import { BaseService } from "services/_baseService";
import appAxios from "services/axios";


class EventsAdminService extends BaseService<any> {
    constructor() {
        super(`events`);
    }
    getEvents = async (leadID: string) => {
        return appAxios.get(`${this.pathWithOrg()}`, { params: { leadID } });
    };

    getTicketEvents = async (ticketID: string) => {
        return appAxios.get(`${this.pathWithOrg()}`, { params: { ticketID } });
    };

    addEvent = async (eventInput: any) => {
        return appAxios.post(`${this.pathWithOrg()}`, eventInput);
    };
    deleteEvent = async (eventID: string) => {
        return appAxios.delete(`${this.pathWithOrg()}/${eventID}`);
    };
}

export default new EventsAdminService();